<div class="table-container">
  <div class="data-card">
    <div class="table-wrapper">
      <table mat-table [dataSource]="dataSource" matSort>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
          <td mat-cell *matCellDef="let row"> {{row.fullName}} </td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
          <td mat-cell *matCellDef="let row"> {{row.email}} </td>
        </ng-container>

        <!-- Auth Type Column -->
        <ng-container matColumnDef="authType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Auth Type </th>
          <td mat-cell *matCellDef="let row"> {{ decodeAuthType(row) }} </td>
        </ng-container>

        <!-- Office Column -->
        <ng-container matColumnDef="office">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Office </th>
          <td mat-cell *matCellDef="let row"> {{row.office | objectdesc}} </td>
        </ng-container>

        <!-- Agency Column -->
        <ng-container matColumnDef="agency">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Agency </th>
          <td mat-cell *matCellDef="let row"> {{row.agency | objectdesc}} </td>
        </ng-container>

        <!-- Last Login Column -->
        <ng-container matColumnDef="lastLogin">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Login </th>
          <td mat-cell *matCellDef="let row"> {{row.lastLogin | date:'d/M/yyyy'}} </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let row">
            <div class="actions">
              <button matButton class="act-btn" (click)="onEditUser(row)" matTooltip="Edit User">
                <i class="fa-solid fa-pen"></i>
              </button>
              <button matButton class="act-btn danger" (click)="onDeleteUser(row)" matTooltip="Delete User">
                <i class="fa-regular fa-trash-can"></i>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <mat-paginator
      [pageSizeOptions]="[10, 25, 50, 100]"
      showFirstLastButtons
      aria-label="Select page">
    </mat-paginator>
  </div>

  <button class="fab fab-left" (click)="onNewUser()">
    <i class="fa-solid fa-plus"></i>
    New User
  </button>

</div>
